import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListModulePaginationMeta } from './list-module.types';

@Component({
  selector: 'app-list-module-pagination',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="meta && meta.total > 0"
      class="flex flex-wrap items-center justify-between gap-3 border-t border-dashed border-gray-200 py-3 dark:border-[#191e3a]"
    >
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Showing
        <span class="font-medium text-dark dark:text-white">{{ rangeStart }}</span>
        –
        <span class="font-medium text-dark dark:text-white">{{ rangeEnd }}</span>
        of
        <span class="font-medium text-dark dark:text-white">{{ meta.total }}</span>
      </p>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="btn rounded-full bg-white px-4 py-2 text-sm dark:bg-dark"
          [disabled]="meta.currentPage <= 1 || loading"
          (click)="pageChange.emit(meta.currentPage - 1)"
        >
          Previous
        </button>
        <span class="text-sm text-gray-500">Page {{ meta.currentPage }} / {{ meta.lastPage }}</span>
        <button
          type="button"
          class="btn rounded-full bg-white px-4 py-2 text-sm dark:bg-dark"
          [disabled]="meta.currentPage >= meta.lastPage || loading"
          (click)="pageChange.emit(meta.currentPage + 1)"
        >
          Next
        </button>
      </div>
    </div>
  `,
})
export class ListModulePaginationComponent {
  @Input() meta: ListModulePaginationMeta | null = null;
  @Input() rowCount = 0;
  @Input() loading = false;

  @Output() pageChange = new EventEmitter<number>();

  get rangeStart(): number {
    if (!this.meta) return 0;
    return (this.meta.currentPage - 1) * this.meta.perPage + 1;
  }

  get rangeEnd(): number {
    if (!this.meta) return 0;
    return (this.meta.currentPage - 1) * this.meta.perPage + this.rowCount;
  }
}
